/**
 * @param {String} type
 * @param {Object} scenario
 * @param {String} input
 */

// @todo - figure out how to deprecate this properly
export default function calculate(type, scenario, input) {}
